import { Icon } from "@iconify/react";
import React from "react";
import { Form } from "react-bootstrap";

export default function FormControlCustom({
  isInvalid,
  isInvalidMessage,
  ...other
}) {
  return (
    <div>
      <Form.Control isInvalid={isInvalid} {...other} />
      <div
        style={{
          display: isInvalid && isInvalidMessage ? "flex" : "none",
          color: "#FF0000",
          gap: 5,
          alignItems: "center",
          marginTop: 5
        }}
      >
        <Icon
          icon="material-symbols:info-outline"
          style={{ width: 18, height: 18 }}
        />
        <span>{isInvalidMessage}</span>
      </div>
    </div>
  );
}
